// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"ae736fbd","674":"9c33ec88"}[chunkId] + ".chunk.css";
};